import * as React from "react";
import styled from "styled-components";
import theme from "../ui/theme";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Map from "../ui/map";

const Container = styled.div`
  width: 100vw;
  height: auto;
  padding-bottom: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ContentContainer = styled.div`
  padding-top: 100px;
  display: flex;
  flex-direction: column;
`;
const Profile = styled.div`
  display: flex;
  flex-direction: row;
  p {
    margin: 20px 20px 0px 0px;
  }
  a {
    color: ${theme.common.black};
    margin: 10px 0 0 0;
  }
`;
const WProfile = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  a {
    color: ${theme.common.black};
    margin: 10px 0 0 0;
  }
  img {
    height: 100px !important;
    width: auto !important;
  }
`;
const Profilecontainer = styled.div`
  width: 60vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  div {
    flex-grow: 1;
  }
  @media only screen and (max-width: 900px) {
    width: 80vw;
    flex-direction: column;
    gap: 50px;
    align-items: start;
  }
`;

const WProfilecontainer = styled.div`
  margin-top: 40px;
  width: 60vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  div {
    align-items: center;
  }
  @media only screen and (max-width: 900px) {
    width: 80vw;
    flex-direction: column;
    gap: 50px;
    align-items: start;
  }
`;
const Lokaal = styled.div`
  width: 60vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 100px;
  @media only screen and (max-width: 900px) {
    width: 80vw;
    flex-direction: column;
    gap: 50px;
    margin-top: 20px;
  }
  p {
    margin: 10px 0 0 0;
  }
  a {
    color: ${theme.common.black};
    margin: 10px 0 0 0;
  }
`;
const Box = styled.div`
  width: 30vw;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 900px) {
    width: 80vw;
  }
`;
const Phone = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  p {
    color: ${theme.common.black};
    margin: 10px 0 0 0;
    font-size: 1rem;
  }
`;

const GalleryContainer = styled.div`
  margin: 50px 0 0 0;
  width: 90vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
`;

const GatsbyImageContainer = styled(GatsbyImage)`
  flex-grow: 1;
  img {
    height: 24vw !important;
    width: auto !important;
    max-height: 100%;
    min-width: 100%;
    object-fit: cover;
    color: ${theme.common.white};
    @media only screen and (max-width: 1000px) {
      height: auto !important;
      width: 100%;
    }
  }
`;

const Lokaalenbestuur = ({ data }) => {
  const queryGallery = useStaticQuery(graphql`
    query MyQuery {
      strapiLokaal {
        id
        gallery {
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, width: 5760, quality: 80)
            }
          }
        }
      }
    }
  `);
  return (
    <>
      <Container>
        <ContentContainer>
          <h2>Bestuur</h2>
          <Profilecontainer>
            <div>
              <Profile>
                <p>
                  <b>Voorzitter:</b> Schotte Geert
                </p>
              </Profile>

              <Profile>
                <p>
                  <b>Secretaris:</b> Van Snick Andre
                </p>
              </Profile>

              <Profile>
                <p>
                  <b>Schatbewaarder:</b> Lapage Noël
                </p>
              </Profile>
              <Profile>
                <p>
                  <b>Bestuurslid & rangschikker:</b> Van Crombrugghe Hendrik
                </p>
              </Profile>
            </div>
            <div>
              <Profile>
                <p>
                  <b>Lokaalhouder:</b> Poisson Steven
                </p>
              </Profile>

              <Profile>
                <p>
                  <b>Ondervoorzitter:</b> Jalet Jannick
                </p>
              </Profile>

              <Profile>
                <p>
                  <b>Adj. secretaris:</b> Vanderbracht Jan
                </p>
              </Profile>

              <Profile>
                <p>
                  <b>Adj. schatbewaarder: </b> Leus Danny
                </p>
              </Profile>
            </div>
          </Profilecontainer>
          <WProfilecontainer>
            <WProfile>
              <StaticImage
                placeholder="blurred"
                quality={100}
                src="../../images/kruis.png"
                alt="de kat balie"
              />
              <p>
                <b>Ere-lid & kapitein : </b> Poisson Walter
              </p>
            </WProfile>
          </WProfilecontainer>
        </ContentContainer>
        <ContentContainer>
          <h2>Lokaal</h2>
          <Profilecontainer>
            <Lokaal>
              <Box>
                <p>
                  <b>Cafe De Kat</b>
                </p>
                <p>Brambroek 1 </p>
                <p>B-9500 Ophasselt</p>
              </Box>
              <Box>
                <Phone>
                  <p>Mail: </p>
                  <a href="mail:contact@dekat-devrijheid.be">
                    contact@dekat-devrijheid.be
                  </a>
                </Phone>

                <Phone>
                  <p>Tel. :</p>
                  <a href="tel:0479397838"> +32 (0)479 39 78 38</a>
                  <p>(Geert)</p>
                </Phone>
              </Box>
            </Lokaal>
          </Profilecontainer>
        </ContentContainer>
        <ContentContainer>
          <GalleryContainer>
            {queryGallery.strapiLokaal.gallery.map((image, i) => (
              <GatsbyImageContainer
                id={i}
                image={getImage(
                  image.localFile.childImageSharp.gatsbyImageData
                )}
                alt={image.name}
                key={image.name}
              />
            ))}
          </GalleryContainer>
        </ContentContainer>
        <ContentContainer>
          <Map />
        </ContentContainer>
      </Container>
    </>
  );
};
export default Lokaalenbestuur;
